import { render, staticRenderFns } from "./ChatPrivateSide.vue?vue&type=template&id=d105699a&scoped=true"
import script from "./ChatPrivateSide.vue?vue&type=script&lang=js"
export * from "./ChatPrivateSide.vue?vue&type=script&lang=js"
import style0 from "./ChatPrivateSide.vue?vue&type=style&index=0&id=d105699a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../新版代码/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d105699a",
  null
  
)

export default component.exports